/**
 * Order calculation utilities
 * Extracted from Order.js for better maintainability and testability
 */

/**
 * Calculate the total amount for an order including items and donation
 * @param {Object} orderData - The order object containing fundraiserOrderItems and donation
 * @returns {number} - The calculated total amount
 */
export const calculateTotal = (orderData) => {
    let _total = 0;
    let grandTotal = 0;

    
    orderData.fundraiserOrderItems?.forEach(x => {
        x.fundraiserOrderItemOptions?.forEach(y => {
            if (y.qty > 0) {

                _total += y.qty * y.price;
            }
        });
    });
    
    grandTotal = _total + (parseFloat(orderData.donation || 0));

    return grandTotal;
};

/**
 * Round a number to the nearest hundredth (2 decimal places)
 * @param {number} value - The value to round
 * @returns {string|number} - The rounded value as a string with 2 decimal places, or 0 if invalid
 */
export const roundToHundredth = (value) => {
    let placeMaker = value * 100;
    if (placeMaker !== "NaN")
        return (placeMaker / 100).toFixed(2);
    return 0;
};
